<template>
  <div class="order-detail" v-if="isShow">
    <div class="order-status" v-if="orderDetail.orderState === 0">
      <div class="title">待支付</div>
      <div class="detail">
        <van-count-down :time="orderDetail.remainingTime" format="mm" @finish="cancelOrder" style="display: inline-block">
          <template #default="timeData">
            <span style="color: #FFFFFF;font-size: 16px;">剩{{ timeData.minutes }}分钟订单自动关闭</span>
          </template>
        </van-count-down>
      </div>
    </div>
    <div class="order-status" v-if="orderDetail.orderState === 1">
      <div class="title">待成团</div>
      <div class="detail">还剩{{ orderDetail.remainingNumber }}人成团，请您在成团后再购买来回票</div>
    </div>
    <div class="order-status" v-if="orderDetail.orderState === 2">
      <div class="title">待出行</div>
      <div class="detail">请您及时购买来回机票并准时出行，祝您旅途愉快</div>
    </div>
    <div class="order-status" v-if="orderDetail.orderState === 3">
      <div class="title">已完成</div>
      <div class="detail">您已成功出行，感谢您的支持</div>
    </div>
    <div class="order-status" v-if="orderDetail.orderState === 4">
      <div class="title">已取消</div>
      <div class="detail" v-if="orderDetail.cancelReason === '订单超时未支付，自动取消'">支付超时，您的订单金额将在3个工作日内原路退回</div>
      <div class="detail" v-else-if="orderDetail.cancelReason === '用户主动取消订单'">用户主动取消订单，您的订单金额将在3个工作日内原路退回</div>
      <div class="detail" v-else-if="orderDetail.cancelReason === '成团失败，自动取消'">到期未达最低人数，您的订单金额将在3个工作日内原路退回</div>
      <div class="detail" v-else>{{ orderDetail.cancelReason }}</div>

    </div>
    <div class="main">
      <div class="tag">(昆明本地团)云南康养之旅-康享云巅6天 5晚 康养之旅(不含来回昆明费用)</div>
      <div class="num">
        <span class="title">出游人数</span>
        <span class="txt" v-if="orderDetail.adultNum > 0">成人*{{ orderDetail.adultNum }}</span>
        <span class="txt" v-if="orderDetail.familyNum > 0">家庭*{{ orderDetail.familyNum }}</span>
      </div>
      <div class="date">
        <span class="title">出行日期</span>
        <span class="txt">{{orderDetail.skuDate}}</span>
      </div>
    </div>
    <div class="user-info">
      <div class="tag">联系人信息</div>
      <div class="linkman-info">
        <span class="name">{{ orderDetail.linkmanName }}</span>
        <span class="mobile">{{ orderDetail.linkmanMobile }}</span>
      </div>
      <div class="bar"></div>
      <div class="tag">出行人</div>
      <div class="trip-user" v-for="user in orderDetail.personInfoList">
        <span class="name">{{ user.realName }}</span>
        <span class="age">{{ user.age }}岁</span>
        <span class="identityNo">{{ user.identityNo }}</span>
      </div>
    </div>
    <div class="order-info">
      <div class="tag">订单信息</div>
      <div class="order-code">
        <span class="title">订单号</span>
        <span class="content">{{ orderDetail.orderCode }}</span>
      </div>
      <div class="pay-type">
        <span class="title">支付方式</span>
        <span class="content">{{ handlePayType() }}</span>
      </div>
      <div class="pay-time">
        <span class="title">下单时间</span>
        <span class="content">{{ orderDetail.createdAt }}</span>
      </div>
    </div>
    <div class="footer">
      <a class="customer-service" :href="getServicePhoneTel()" v-if="orderDetail.orderState !== 0">
        <img src="./img/customer-service.png">
        <div class="txt" style="color: #222222">
          联系客服
        </div>
      </a>
      <div class="right">
        <div class="cancel-order" @click="cancelOrder" v-if="orderDetail.orderState === 0 || orderDetail.orderState === 1">取消订单</div>
        <div class="pay-directly" @click="toPay" v-if="orderDetail.orderState === 0">立即支付</div>
      </div>
    </div>
  </div>
</template>

<script>
import apiUtil from "../../apiUtil";
import {Toast} from "vant";
import { getServicePhoneTel } from '@/utils/common';

export default {
  name: "orderDetail",
  data() {
    return {
      orderDetail: {},
      orderCode: '',
      isShow: false
    }
  },
  async created() {
    this.orderCode = this.$route.query.orderCode;
    await this.getOrderDetail();
  },
  methods: {
    getServicePhoneTel,
    handlePayType() {
      switch (this.orderDetail.payType) {
        case 0: return '-';
        case 1: return '普康宝';
        case 2: return '微信';
        case 10: return '普康宝+微信';
      }
    },
    async cancelOrder() {
      let res = await apiUtil.apiUtilPostNoParam(`/PKECUser/ynky/cancelOrder?orderCode=${this.orderCode}&cancelReason=`);
      if (res.errorCode === 0) {
        await this.getOrderDetail();
      } else {
        Toast.fail(res.errorMessage);
      }
    },
    async toPay() {
      let rst = await apiUtil.apiUtilPost(`/PKECUser/servOrder/${this.orderCode}/payByPKPayProxy`, this.orderDetail.servOrderCreateVo);
      if (rst.errorCode === 0) {
        localStorage.setItem('orderCode', this.orderCode);
        window.location.href = rst.data.jumpUrl;
      } else {
        Toast.fail(res.errorMessage);
      }
    },
    async getOrderDetail() {
      let res = await apiUtil.apiUtilGetUrl(`/PKECUser/ynky/getOrderDetail/${this.orderCode}`);
      if (res.errorCode === 0) {
        this.orderDetail = res.data;
        this.isShow = true;
      } else {
        Toast.fail(res.errorMessage);
        this.isShow = false;
      }
    }
  }

}
</script>

<style scoped lang="less">
.order-detail {
  img {
    -webkit-touch-callout: none;
    //pointer-events: none;
  }
  .order-status {
    position: relative;
    width: 100%;
    height: 160px;
    background-color: #ff931f;
    color: #FFFFFF;
    .title {
      padding-top: 16px;
      font-size: 20px;
      font-weight: bold;
      margin-left: 25px;
    }
    .detail {
      margin-top: 5px;
      margin-left: 25px;
      margin-right: 25px;
      font-size: 16px;
    }
  }
  .main {
    position: relative;
    z-index: 1;
    margin: -55px 12px 0;
    padding: 21px 18px 18px 12px;
    border-radius: 8px;
    background-color: #fff;
    .tag {
      color: #222222;
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 18px;
    }
    .num {
      padding: 0 12px 15px;
    }
    .date {
      padding: 0 12px;
    }
    .num, .date {
      font-size: 14px;
      .title {
        color: #828282;
      }
      .txt {
        color: #393939;
        margin-left: 20px;
      }
    }
  }
  .user-info {
    background-color: #fff;
    margin: 9px 12px 0;
    padding: 0 0 3px 12px;
    border-radius: 8px;
    .tag {
      padding: 15px 0;
      font-size: 16px;
      color: #222222;
      font-weight: bold;
    }
    .linkman-info,
    .trip-user {
      margin-bottom: 15px;
      span {
        font-size: 14px;
        color: #393939;
        display: inline-block;
      }
      .name {
        width: 70px;
      }
      .age {
        width: 70px;
      }
    }
    .bar {
      width: 100%;
      height: 1px;
      background-color: #E9E9E9;
    }
  }
  .order-info {
    background-color: #fff;
    margin: 9px 12px 105px;
    padding: 0 0 3px 12px;
    border-radius: 8px;
    .tag {
      padding: 15px 0;
      font-size: 16px;
      color: #222222;
      font-weight: bold;
    }
    .order-code,
    .pay-type,
    .pay-time {
      margin-bottom: 15px;
      span {
        display: inline-block;
        font-size: 14px;
      }
      .title {
        color: #393939;
        width: 70px;
      }
      .content {
        color: #828282;
      }
    }
  }
  .footer {
    width: 100%;
    height: 80px;
    background-color: #fff;
    position: fixed;
    bottom: 0;
    .customer-service {
      text-align: center;
      padding: 14.5px 0 6px 20px;
      img {
        width: 19px;
        height: 17px;
      }
      font-size: 10px;
      float: left;
    }
    .right {
      float: right;
      width: calc(100% - 110px);
      padding-right: 12px;
      margin-top: 9px;
      div {
        float: right;
        display: inline-block;
        width: 47%;
        height: 40px;
        font-size: 16px;
        line-height: 40px;
        text-align: center;
        border-radius: 20px;
      }
      .cancel-order {
        width: calc(47% - 2px);
        height: 38px;
        color: #393939;
        border: 1px solid #ff931f;
        background-color: #fff;
      }
      .pay-directly {
        margin-left: 6%;
        background-color: #ff931f;
        color: #FFFFFF;
      }
    }
  }
}
</style>